import { GenericApiService, ISingleApiResponse } from "src/api/API_GenericService";
import { IIsOpen } from "src/models/General/General.models";
const ApiService = new GenericApiService<ISingleApiResponse<IIsOpen>>();

const SetIsOpen = (endpoint: string, id: number, isOpen: boolean) => {
    return new Promise<ISingleApiResponse<IIsOpen>>(async (resolve, reject) => {
        try {
        const response = await ApiService.setIsOpen(endpoint, id, isOpen);
        resolve(response);
        } catch (exception) {
        reject(exception);
        }
    });
};

const RevokeIsOpenForCurrentUser = (endpoint: string) => {
    return new Promise<ISingleApiResponse<any>>(async (resolve, reject) => {
        try {
        const response = await ApiService.revokeIsOpenForCurrentUser(endpoint);
        resolve(response);
        } catch (exception) {
        reject(exception);
        }
    });
};

export {
    SetIsOpen,
    RevokeIsOpenForCurrentUser,
};